export function getApplicantName(applicant) {
  const answers = applicant.answers ?? {};
  const coapplicantInvitation = applicant.coapplicantInvitation ?? {};
  const landlordInvitation = applicant.landlordInvitation ?? {};
  if (answers.firstName || answers.middleName || answers.lastName) {
    const { firstName, middleName, lastName } = answers;
    return [firstName, middleName, lastName].filter(Boolean).join(' ');
  }
  if (landlordInvitation.firstName || landlordInvitation.lastName) {
    const { firstName, lastName } = landlordInvitation;
    return [firstName, lastName].filter(Boolean).join(' ');
  }
  if (coapplicantInvitation.firstName || coapplicantInvitation.lastName) {
    const { firstName, lastName } = coapplicantInvitation;
    return [firstName, lastName].filter(Boolean).join(' ');
  }
  return 'Name not provided';
}

export function getApplicantFirstName(applicant) {
  return (
    applicant?.answers?.firstName ??
    applicant?.landlordInvitation?.firstName ??
    applicant?.coapplicantInvitation?.firstName
  );
}

export function getApplicantEmail(applicant) {
  const answers = applicant.answers ?? {};
  const coapplicantInvitation = applicant.coapplicantInvitation ?? {};
  const { submittedDateTime } = applicant;
  const hasSubmitted = Boolean(submittedDateTime);
  if (hasSubmitted) {
    return answers.email;
  }
  const { email } = coapplicantInvitation;
  return email;
}
